import React from "react";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState } from "react";
import { useMemo } from "react";

function SubModules() {
  const navigate = useNavigate();
  const handleEdit = (workload) => {
    navigate(`/provider/work-order/edit`, {
      state: { draft: workload.workorderedit },
    });
  };

  const tableStyle = `
    .ag-theme-quartz .ag-header-cell-filter-button{
   display: none;}

   .ag-paging-panel{
display: flex;
justify-content: space-between;
}

.ag-paging-row-summary-panel{
display: none;
}

.ag-header-cell-label{
display: flex;
justify-content: center;
}

.ag-ltr .ag-cell {
   display: flex;
   justify-content: center;
}

    `;

  const [rowData, setRowData] = useState([
    {
      ModuleNumber: "1",

      SubModuleName: "Maintenance",

      Status: "",

      StartDate: "Jan 6, 2024",

      EndDate: "Jan 6, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "2",

      SubModuleName: "Patient Portal",

      Status: "",

      StartDate: "Jan 6, 2024",

      EndDate: "Jan 6, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "3",

      SubModuleName: "Appointment Schedule",

      Status: "",

      StartDate: "Jan 6, 2024",

      EndDate: "Jan 6, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "4",

      SubModuleName: "Facility Management",

      Status: "",

      StartDate: "Jan 5, 2024",

      EndDate: "Jan 5, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "5",

      SubModuleName: "Physician Management",

      Status: "",

      StartDate: "Jan 5, 2024",

      EndDate: "Jan 5, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "6",

      SubModuleName: "Pharmacy Management",

      Status: "",

      StartDate: "Jan 5, 2024",

      EndDate: "Jan 5, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "7",

      SubModuleName: "Laboratory Management",

      Status: "",

      StartDate: "Jan 4, 2024",

      EndDate: "Jan 4, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "8",

      SubModuleName: "Bed Management",

      Status: "",

      StartDate: "Jan 3, 2024",

      EndDate: "Jan 3, 2024",

      Actions: "",
    },

    {
      ModuleNumber: "9",

      SubModuleName: "Physiotherapy",

      Status: "",

      StartDate: "Jan 3, 2024",

      EndDate: "Jan 3, 2024",

      Actions: "",
    },
  ]);

  const [colDefs, setColDefs] = useState([
    { field: "ModuleNumber", filter: true, headerName: "" },
    { field: "SubModuleName", filter: true, headerName: "Sub Module Name" },
    {
      field: "Status",
      headerName: "Status",
      cellRenderer: (param) => {
        return (
          <>
            <div className="div-MPPwiusxtE">
              <button
                type="button"
                data-bs-toggle="button"
                className="btn"
                style={{ background: "#FAAB3C", color: "#fff" }}
              >
                Active
              </button>
            </div>
          </>
        );
      },
      filter: false,
    },
    { field: "StartDate", filter: true, headerName: "Start Date" },
    { field: "EndDate", filter: true, headerName: "End Date" },
    {
      field: "Actions",
      headerName: "Actions",
      cellRenderer: (param) => {
        return (
          <>
            <div className="div-WZWR4m5wwn">
              <button
                type="button"
                data-bs-toggle="button"
                className="rounded-2"
                style={{
                  color: "#5541D7",
                  border: "solid 1px #5541D7",
                  width: "6rem",
                }}
              >
                Edit
              </button>
              <button
                type="button"
                data-bs-toggle="button"
                className="rounded-2"
                style={{
                  color: "#FFFFFF",
                  background: "#F04461",
                  width: "6rem",
                }}
              >
                Delete
              </button>
            </div>
          </>
        );
      },
      filter: false,
    },
  ]);
  const defaultColDef = useMemo(() => {
    return {
      width: 200,
      sortable: true,
    };
  }, []);

  const [paginationPageSize, setPaginationPageSize] = useState(20);

  return (
    <>
      <div id="main-submodules" className="container">
        <div className="row">
          <div className="col-12 mb-3">
            <h4 className="fw-bold h4-agdansasjaio">Sub-Modules</h4>
          </div>

          <div className="col-12 mb-4">
            <div className="d-flex flex-column gap-3">
              <span style={{ color: "#333333", fontSize: "14px" }}>
                Module{" "}
              </span>
              <Form.Select
                aria-label="Default select example"
                className="div-dsfuidsdygfis"
              >
                <option>Module 1</option>
                <option value="1">Module 2</option>
                <option value="2">Module 3</option>
                <option value="3">Module 4</option>
              </Form.Select>
            </div>
          </div>

          <div className="col-12 mb-4">
            <div className="d-flex flex-column gap-3">
              <span style={{ color: "#333333" }}>Module </span>

              <div
                className="ag-theme-quartz"
                style={{
                  width: "100%",
                }}
              >
                <style>{tableStyle}</style>
                <AgGridReact
                  rowData={rowData}
                  columnDefs={colDefs}
                  defaultColDef={defaultColDef}
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  domLayout="autoHeight" // Automatically adjusts grid height based on content
                  rowHeight={50}
                  autoSizeStrategy={{
                    type: "fitGridWidth",
                    defaultMinWidth: 100,
                    columnLimits: [
                      {
                        colId: "ModuleNumber",
                        maxWidth: 10,
                      },

                      {
                        colId: "ModuleName",
                        maxWidth: 800,
                      },
                    ],
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-12 mb-3">
            <a href="/AddSubModules">
              {" "}
              <button type="button" className="div-ButtonGreen">
                Add Sub-Module
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubModules;
